export const VARIABLE_PREFIX = 'var';
export const FUNCTION_PREFIX = 'func';
export const BLOCK_PREFIX = 'b';
export const ENTITY_PREFIX = 'e'; // mongo id prefix for backend entities
export const NAV_ITEM_PREFIX = 'nav';
export const PAGE_EVENT_PREFIX = 'p_evt';
export const GLOBAL_FILTER_ITEM_PREFIX = 'gfItem';
export const PAGE_INPUT_QUERY_KEY = 'pageInputs';
export const EVENT_PREFIX = 'evt';
export const ACTION_PREFIX = 'act';
export const ROW_ACTION_PREFIX = 'rowAct';
export const BULK_ACTION_PREFIX = 'bulkAct';
export const COLUMN_ACTION_PREFIX = 'colAct';
export const REQUEST_ID_PREFIX = 'req';
export const MULTI_STAT_CARD_SECONDARY_STAT_PREFIX = 'secStat';
export const KEY_VALUE_FIELD_PREFIX = 'kvF';
export const FORM_VALIDATION_RULES_PREFIX = 'f_vRules';
export const STEPPED_CONTAINER_ITEM_PREFIX = 'stepItem';
export const COLUMN_PREFIX = 'col';
export const NAV_MENU_ITEM_PREFIX = 'navMenuItem';
export const NAVIGATION_CONTAINER_ITEM_PREFIX = 'navContainerItem';
export const COMMENT_PREFIX = 'comment';
export const REPLY_PREFIX = 'reply';
export const FIELD_ID_PREFIX = 'F';
export const MEDIA_ID_PREFIX = 'media';
export const MESSAGE_INPUT_ACTION = 'messageInputAct';
export const CASCADER_OPTION_PREFIX = 'cascaderOption';
export const TABLE_TOOLBAR_ACTION_PREFIX = 'ttA';

export const HEADER_ID = 'header_id';
export const ROOT_ID = 'root_id';
export const FOOTER_ID = 'footer_id';

export const EXPORT_HEADER_ID = 'export_header_id';
export const EXPORT_FOOTER_ID = 'export_footer_id';

export const BLOCK_STYLES = 'block-styles';
export const INTERNALS_PARAMETERS_KEY = '__internals__';
export const CLIENT_KEY = '__ua_client__';

export const RUN_TIME_BLOCK_KEY = 'runTimeBlockKey';

//to differentiate between block and placeholder block
export const PLACEHOLDER = 'placeholder';
//for dnd on pill
export const OVERLAY_PILL = 'overlayPill';

export const ENTITY_DATA_SOURCE_PREFIX = 'entityDataSource';
// Action constants
export const ENTITY_DATA_SOURCE_SEPARATOR = '$';

export const interfacePatterns = {
  subDomain: '^(?!-)(?!.*--)[a-z0-9-]+(?<!-)$',
};

/**
 * Controls whether to disable Suspense boundaries in the GlobalStateStore.
 *
 * Why this is set to false:
 * During navigation between pages in the matrix app using AppSideNav, Next.js performs
 * the following sequence:
 *
 * 1. When navigating between pages (e.g., A → B), Next.js makes a request to fetch
 *    the React Server Component (RSC) for the target page
 *
 * 2. While this RSC request is in flight, Next.js attempts to show loading states in
 *    this order:
 *    a. First tries to find and use loading.tsx in the [interfacePageSlug]/loading.tsx or higher in the layout hierarchy (we don't have this in matrix)
 *    b. If not, then it falls back to the closest Suspense boundary in the page's component hierarchy
 *
 * 3. Without this flag set to true, users would see loading states during navigation
 *    even for cached/previously visited pages due to the RSC fetch
 *
 * To reproduce this behavior:
 * 1. Set this to true
 * 2. Create two pages: one with a table, one with simple text
 * 3. Visit both pages at least once in matrix
 * 4. Enable 6x CPU slowdown and 3G network throttling in Chrome DevTools
 * 5. Navigate between the pages - you'll see unnecessary loading states
 */
export const WITH_SUSPENSE = false;

export const INITIAL_TRANSFORMER_CODE = `// Query response is available as the \`data\` variable\nreturn data;`;
export const DUMMY_INTERFACE_RECORD_ID = 'dummy-id';
